import { useState, useEffect } from 'react';
export function useIsMounted(allowTests) {
    if (allowTests === void 0) { allowTests = false; }
    var _a = useState(false), mounted = _a[0], setMounted = _a[1];
    useEffect(function () {
        if (!allowTests && process.env.NODE_ENV === 'test') {
            return;
        }
        setMounted(true);
    }, [allowTests]);
    return mounted;
}
//# sourceMappingURL=useIsMounted.js.map